const ITEMS = [
  "Repair · Support · Solve",
  "Fast 24h Express",
  "SSD & RAM Boost Upgrades",
  "Virus & Malware Sterilization",
  "Mac Logic Board Specialists",
  "52 Jalan Kembangan",
  "Zero Data Loss Protocol",
  "Up To 20% Off — Limited Time",
  "Refurbished Laptops From S$300+",
  "Print · Copy · Scan · Shred",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-brand-lime/25 bg-navy/60 py-5"
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {row.map((item, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-display text-2xl sm:text-3xl font-bold uppercase tracking-wide text-white/90 px-6">
              {item}
            </span>
            <span className="text-brand-lime text-xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
